export default __webpack_public_path__ + "static/top-bg-2a757011bd9bea3662962f2de1303518.png";